module.exports = __webpack_public_path__ + "img/40.3da2252b.jpg";